var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dbc-dygraphs-dth"},[_c('db-dygraphs',{ref:"dygraph",attrs:{"_updated":_vm._updated,"data":_vm.data,"options":_vm.graphOptions,"dark":_vm.dark}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }